import { SPAM_TYPES } from "../../config/constants";

export const getSpamTypeValue = (type) => {
  const t = SPAM_TYPES.find(({ value }) => value === type);
  if (t) return t.label;
  else return null;
};
